import React from 'react';
import {Link} from 'react-router-dom';
import Landing from '../../layouts/Landing';
import LogoImage from './images/logo.png';
import GooglePlayImage from './images/google-play.png';
import {path as PrivacyPolicyPath} from '../PrivacyPolicy';
import './styles.scss';

export const path = '/';

const listData = [
  'Создание заявок на спецтехнику',
  'Мониторинг статусов',
  'Согласование техники прикрепленной Центральной Диспетчерской Службой',
  'Ежедневное подтверждение выполненных работ посредством заполнения журналов учета техники',
];

const Home = () => {
  return (
    <Landing>
      <section className="s-home">
        <p className="s-home__logo logo">
          <img className="logo__image" src={LogoImage} alt="" />
          <span className="logo__text">Park</span>
        </p>
        <p className="s-home__text">
          Корпоративное мобильное приложение BI Group для заказа спецтехники
        </p>
        <ul className="s-home__list">
          {listData.map((text, index) => (
            <li key={index}>
              <p className="s-home__text">{text}</p>
            </li>
          ))}
        </ul>
        <p className="s-home__text--large">По различным вопросам обращаться</p>
        <div className="s-home__contacts">
          <p className="s-home__text">
            Телефон: &nbsp;<a href="tel:+77471033004" className="s-home__link">+7 (747) 103 30 04</a>
          </p>
          <p className="s-home__text">
            Эл. почта: &nbsp;<a href="mailto:azhimbayev_m@bi.group" className="s-home__link">azhimbayev_m@bi.group</a>
          </p>
        </div>
        <div className="s-home__apps">
          <a href="https://play.google.com/store/apps/details?id=kz.otgroup.bipark" target="_blank">
            <img src={GooglePlayImage} alt="" />
          </a>
        </div>
        <Link to={PrivacyPolicyPath} className="s-home__privacy-policy">Политика конфиденциальности</Link>
        <p className="s-home__copyright">&copy; BI Innovations 2020</p>
      </section>
    </Landing>
  )
};

export default Home;
